module.exports = __webpack_public_path__ + "static/media/android-desk.92cd9223.svg";